import { put, takeLatest, call, select, take } from "redux-saga/effects";
import { eventChannel, END } from "redux-saga"
import {
    getWorkOrderBayesianDataRequest,
    getWorkOrderBayesianDataSuccess,
    getWorkOrderBayesianDataFailure,
    getPredictExperimentRequest,
    getPredictExperimentFailure,
    getPropertiesExtrapolationRequest,
    getPropertiesExtrapolationSuccess,
    getPropertiesExtrapolationFailure,
    getPredictionHistoryListRequest,
    getPredictionHistoryListFailure,
    getPredictionHistoryListSuccess,
    getPredictionHistoryDetailsDataRequest,
    getPredictionHistoryDetailsDataFailure,
    getPredictionHistoryDetailsDataSuccess,
    getPredictionHistoryDetailFilterRequest,
    getPredictionHistoryDetailFilterSuccess,
    getPredictionHistoryDetailFilterFailure,
    deletePredictionHistoryRequest,
    deletePredictionHistoryFailure,
    deletePredictionHistorySuccess,
    getPredictExperimentSuccess,
    fetchProjectListFiltersOptionRequest,
    fetchProjectListFiltersOptionFailure,
    fetchProjectListFiltersOptionSuccess
} from "../actions/extrapolation";
import { message, notification } from "antd";
import { LanguageUnion } from "src/utils/useTranslate";
import { StoreState } from "../configureStore";
import jwtManager from "src/utils/jwtManager";
import { deletePredictionHistory, filterBayesianDataApi, getPredictionHistoryDetailFilter, getPredictionHistoryDetails, getPredictionHistoryList, getPropertiesExtrapolation, predictExperimentBayesianSocket, projectFilterOptions } from '../../services/extrapolation';
import { messages } from "src/utils/hooks";


function* getWorkOrderBayesianDataRequestSaga({
    payload: payloadData,
}: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    );

    const configs = yield select((state: StoreState) => state.configs.features);

    const { payload } = payloadData;


    try {
        const { defaultHeaders } = yield select((state) => state);
        const headers = { ...defaultHeaders, token: jwtManager.getToken() };

        const fetchDataApi = filterBayesianDataApi;

        const {
            data: {
                result: { data, status, message },
            },
        } = yield call(
            fetchDataApi,
            { ...payload, use_processing_profiles: configs?.nestle_configs },
            headers
        );

        if (status === "Success") {
            if (!!data?.dataframe?.length) {
                yield put(getWorkOrderBayesianDataSuccess(data));
            } else {
                yield put(getWorkOrderBayesianDataFailure());
                notification.error({
                    message: messages[ln].trial_not_found_given_inputs,
                });
            }
        } else {
            yield put(getWorkOrderBayesianDataFailure());
            notification.error({ message });
        }
    } catch (error) {
        yield put(getWorkOrderBayesianDataFailure());
        notification.error({
            message: messages[ln].internal_server_error,
            duration: 5,
        });
    }
}

let socket: WebSocket;
let socketChannel: any;


function isValid(data: any) {
    try {
        JSON.parse(data)
    } catch {
        return false
    }
    return true
}

function* getPropertiesExtrapolationRequestSaga({
    payload: payloadData,
}: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    );

    try {
        const { defaultHeaders } = yield select((state) => state);
        const headers = { ...defaultHeaders, token: jwtManager.getToken() };

        const fetchDataApi = getPropertiesExtrapolation;

        const { status, data } = yield call(
            fetchDataApi,
            payloadData,
            headers
        );

        if (status === 200) {
            yield put(getPropertiesExtrapolationSuccess(data));
        }
    } catch (error) {
        yield put(getPropertiesExtrapolationFailure());
        notification.error({
            message: messages[ln].internal_server_error,
            duration: 5,
        });
    }



}

function* getPredictExperimentDataRequestSaga({
    payload: payloadData,
}: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    );
    const { user_id: key } = yield select(
        (state) => state.login.loginResponse
    )

    let token = jwtManager.getToken()

    let { payload } = payloadData;
    payload["token"] = token
    notification.info({
        message: messages[ln].beyesianInProgress,
        duration: 3,
    })

    if (socket?.readyState !== WebSocket.OPEN) {
        socket = yield call(predictExperimentBayesianSocket, key)
        socketChannel = yield call(createBayesianDataChannel, socket)
    }
    socket.send(JSON.stringify(payload))
    while (true) {
        try {
         
            const payload = yield take(socketChannel)
            if (isValid(payload)) {
                let result = JSON.parse(payload)
                yield put(getPredictExperimentSuccess(result))

                if (result?.success === true) {
                    notification.success({
                        message: messages[ln].beyesianPredisinQueue,
                        duration: 5,
                    })
                    break;
                }
                else if(result?.success === false){
                    notification.error({
                        message: result?.message,
                        duration: 5,
                    })
                    break;
                }
            }
        } catch (error) {
            yield put(getPredictExperimentFailure())
            notification.error({
                message: messages[ln].internal_server_error,
                duration: 5,
            });
        }
        finally{
            socket?.close?.()
			socketChannel?.close?.()
        }
    }


}

function createBayesianDataChannel(socket: WebSocket) {
    return eventChannel((emit) => {
        socket.onmessage = (event: any) => {
            emit(event?.data)
        }

        socket.onclose = () => {
            emit(END)
        }

        const unsubscribe = () => {
            socket.onmessage = null
        }

        return unsubscribe
    })
}

function* getPredictionHistoryListRequestSaga({
    payload: payloadData,
}: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    );

    let { payload } = payloadData;
    payload = JSON.stringify(payload);

    try {
        const { defaultHeaders } = yield select((state) => state);
        const headers = { ...defaultHeaders, token: jwtManager.getToken() };

        const fetchDataApi = getPredictionHistoryList;

        const {
            data: {
                result: { data, status, message,total },
            },
        } = yield call(
            fetchDataApi,
            payload,
            headers
        );
        if (status === "Success") {
            yield put(getPredictionHistoryListSuccess({data,total}));
        } else {
            yield put(getPredictionHistoryListFailure());
            notification.error({ message });
        }
    } catch (error) {
        yield put(getPredictionHistoryListFailure());
        notification.error({
            message: messages[ln].internal_server_error,
            duration: 5,
        });
    }
}

function* getPredictionHistoryDetailsDataRequestSaga({ payload: payloadData }: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    )

    try {
        const { payload } = payloadData;
        const { defaultHeaders } = yield select((state) => state)
        const headers = { ...defaultHeaders, token: jwtManager.getToken() }
        const {
            data: {
                result: { data, status, message: apiMessage },
            },
        } = yield call(getPredictionHistoryDetails, payload, headers)
        if (status === "Success") {
            yield put(getPredictionHistoryDetailsDataSuccess(data))
        } else {
            notification.error({
                message: apiMessage
            })
            yield put(getPredictionHistoryDetailsDataFailure(messages[ln].internal_server_error))
        }
    } catch (error) {
        yield put(getPredictionHistoryDetailsDataFailure(messages[ln].internal_server_error))
        message.error(messages[ln].internal_server_error)
    }
}

function* getPredictionHistoryDetailFilterRequestSaga({ payload: payloadData }: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    )

    try {
        const { payload } = payloadData;
        const { defaultHeaders } = yield select((state) => state)
        const headers = { ...defaultHeaders, token: jwtManager.getToken() }
        const {
            data: {
                result: { data, status, message: apiMessage },
            },
        } = yield call(getPredictionHistoryDetailFilter, payload, headers)
       // console.log(data, status, apiMessage,"filterapi");
        if (status === "Success") {
            yield put(getPredictionHistoryDetailFilterSuccess(data))
        } else {
            notification.error({
                message: apiMessage
            })
            yield put(getPredictionHistoryDetailFilterFailure(messages[ln].internal_server_error))
        }
    } catch (error) {
        yield put(getPredictionHistoryDetailFilterFailure(messages[ln].internal_server_error))
        message.error(messages[ln].internal_server_error)
    }
}

function* deletePredictionHistoryRequestSaga({ payload: payloadData }: any): Generator<any, any, any> {
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    )

    try {
        const { payload } = payloadData;
        const { defaultHeaders } = yield select((state) => state)
        const headers = { ...defaultHeaders, token: jwtManager.getToken() }
        const {
            data: {
                result: { data, status, message: apiMessage },
            },
        } = yield call(deletePredictionHistory, payload, headers)
        if (status === "Success") {
            yield put(deletePredictionHistorySuccess(data))
            notification.success({ message: apiMessage })
        } else {
            yield put(deletePredictionHistoryFailure(apiMessage))
            notification.error({ message: apiMessage })
        }
    } catch (error) {
        yield put(deletePredictionHistoryFailure(messages[ln].internal_server_error))
        message.error(messages[ln].internal_server_error)
    }
}

function* fetchProjectListFiltersOptionRequestSaga():Generator<any, any, any>{
    const ln: LanguageUnion = yield select(
        (state: StoreState) => state.language.current
    )
    try{
        const { defaultHeaders } = yield select((state) => state)
        const headers = { ...defaultHeaders, token: jwtManager.getToken() }

        const {
            data: {
                result: { data, status, message },
            },
        } = yield call(projectFilterOptions, null, headers)

        if(status === "Success"){
            yield put(fetchProjectListFiltersOptionSuccess(data))
        }
        else{
            yield put(fetchProjectListFiltersOptionFailure(message))
            notification.error({ message })

        }
    }
    catch(error){
        yield put(fetchProjectListFiltersOptionFailure(messages[ln].internal_server_error))
        message.error(messages[ln].internal_server_error)
    }

}



export default function* rootSaga(): Generator<any, any, any> {

    yield takeLatest(getWorkOrderBayesianDataRequest, getWorkOrderBayesianDataRequestSaga)
    yield takeLatest(getPropertiesExtrapolationRequest, getPropertiesExtrapolationRequestSaga)
    yield takeLatest(getPredictExperimentRequest, getPredictExperimentDataRequestSaga)
    yield takeLatest(getPredictionHistoryListRequest, getPredictionHistoryListRequestSaga)
    yield takeLatest(getPredictionHistoryDetailsDataRequest, getPredictionHistoryDetailsDataRequestSaga)
    yield takeLatest(getPredictionHistoryDetailFilterRequest, getPredictionHistoryDetailFilterRequestSaga)
    yield takeLatest(deletePredictionHistoryRequest, deletePredictionHistoryRequestSaga)
    yield takeLatest(fetchProjectListFiltersOptionRequest,fetchProjectListFiltersOptionRequestSaga)
}